import { DeviceApi } from "./devices";
import { SitesApi } from "./sites";

export const api = {
  devices: new DeviceApi(),
  sites: new SitesApi()
};
